// libs
import { create } from 'zustand';
// constants
import { INITIAL_STATE } from './constants';
const useCampaignDetailsStore = create((set) => (Object.assign(Object.assign({}, structuredClone(INITIAL_STATE)), { setAggregateMetrics: (metrics) => set({ aggregateMetrics: metrics }), setCampaignPerformanceData: (data) => set((state) => {
        const { campaignPerformance } = state;
        return Object.assign(Object.assign({}, state), { campaignPerformance: Object.assign(Object.assign({}, campaignPerformance), { data }) });
    }), setCampaignPerformanceSelectedRange: (range) => set((state) => {
        const { campaignPerformance } = state;
        return Object.assign(Object.assign({}, state), { campaignPerformance: Object.assign(Object.assign({}, campaignPerformance), { selectedRange: range }) });
    }), clear: () => set(Object.assign({}, structuredClone(INITIAL_STATE))) })));
export default useCampaignDetailsStore;
